// extracted by mini-css-extract-plugin
module.exports = {"title":"share_dialog_title__6jGw8","label":"share_dialog_label__2zBQb","form":"share_dialog_form__19dwC"};